var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProductImageIllustration = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 65,
    viewBox: "0 0 37 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80608 1.71845C2.84044 1.27214 3.21087 0.952148 3.6585 0.952148H32.8678C33.3104 0.952148 33.6784 1.26899 33.719 1.7097C34.3414 8.47002 38.7761 58.2992 34.6749 62.7333C34.6068 62.8068 34.5393 62.8435 34.4452 62.8781C28.9393 64.9009 7.0956 65.4277 2.21011 62.9351C2.07306 62.8652 1.98251 62.7788 1.91734 62.6394C-1.23628 55.8944 2.29579 8.3464 2.80608 1.71845Z",
    fill: "#F4F5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.59358 27.097C7.59206 26.8589 7.78466 26.665 8.02278 26.665H35.5725C35.5725 26.665 36.9438 44.6288 36.426 50.9109L8.1769 51.1169C7.93972 51.1186 7.7461 50.9276 7.74458 50.6904L7.59358 27.097Z",
    fill: "#5D6D98"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.33887,
    y: 9.79102,
    width: 12.5611,
    height: 2.48121,
    rx: 0.429202,
    fill: "#5D6D98"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 4.33887,
    y: 14.1335,
    width: 16.7482,
    height: 1.86091,
    rx: 0.429202,
    fill: "#5D6D98"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProductImageIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/product-image-illustration.3b06166b0947d269e634d2b8eeed2174.svg";